export default {
  'home.title': 'VPAuto live',
  'home.menu.auctioneer': 'Commissaire priseur',
  'home.menu.customer': 'Client',
  'home.menu.hall': 'Salle des ventes',
  'home.menu.operator': 'Opérateur',
  'home.menu.salesperson': 'Commercial',
  'home.menu.sliderimages': 'Slider images',
  'operator.dashboard.openLot': 'Ouvrir le lot',
  'operator.dashboard.openAuctions': 'Ouvrir les enchères',
  'operator.dashboard.pause': 'Mettre en pause',
  'operator.dashboard.restart': 'Restaurer la vente',
  'operator.dashboard.close': 'Clôturer le lot',
  'operator.dashboard.end': 'Terminé',
  'operator.dashboard.ok': 'Ok',
  'operator.dashboard.defaultStep': 'Pas par défaut',
  'operator.dashboard.editPrice': 'Modifier le prix de départ',
  'operator.dashboard.interauctionBid': 'Enchérir Interenchères',
  'operator.dashboard.startTimer': 'Chrono de départ',
  'operator.dashboard.auctionTimer': 'Chrono des enchères',
  'operator.dashboard.hallBid': 'Enchérir salle',
  'operator.auctions.origin': 'Origine',
  'operator.auctions.buyer': "Nom de l'acheteur",
  'operator.auctions.company': 'Société',
  'operator.auctions.user.country': 'Pays',
  'operator.auctions.user.type': 'Type',
  'operator.auctions.user.type.user': 'Particulier',
  'operator.auctions.user.type.society': 'Société',
  'operator.auctions.user.type.pro': 'PRO',
  'operator.auctions.amountHF': 'Montant HF',
  'operator.auctions.amount': 'Montant',
  'operator.auctions.maxBid': 'Offre max',
  'operator.autions.editPrice.modal.title': 'Modifier le prix de départ',
  'operator.autions.editPrice.modal.label': 'Prix de départ',
  'auctioneer.dashboard.status.open': 'En cours',
  'auctioneer.dashboard.status.close': 'Terminé',
  'auctioneer.dashboard.reservePrice': 'Prix de réserve',
  'auctioneer.dashboard.nextAuction': 'Prochaine enchère',
  'auctioneer.dashboard.nextAuction.step': '(Pas de {step} €)',
  'auctioneer.dashboard.reduceReservePrice': "Baisser le prix de réserve à l'enchère en cours",
  'auctioneer.dashboard.award': 'Adjuger',
  'lot.toolbox.label': 'Lot N° {number}',
  'lot.toolbox.next.a11yLabel': 'Lot suivant',
  'lot.toolbox.shutdown.a11yLabel': 'Clôturer la vente',
  'lot.toolbox.previous.a11yLabel': 'Lot précédent',
  'lot.toolbox.first.a11yLabel': 'Aller au premier lot',
  'lot.toolbox.last.a11yLabel': 'Aller au dernier lot',
  'lot.toolbox.modal.changeLot.title': 'Choisissez un lot',
  'lot.toolbox.modal.changeLot.validate': 'Valider',
  'lot.toolbox.modal.changeLot.close': 'Fermer',
  'lot.toolbox.modal.changeLot.error': 'Aucun lot ne correspond à votre recherche',
  'lot.toolbox.modal.closeSale.title': 'Êtes-vous sûr de vouloir clôturer cette vente ?',
  'lot.toolbox.modal.closeSale.yes': 'Oui',
  'lot.toolbox.modal.closeSale.no': 'Non',
  'lot.toolbox.modal.closeAuction.title': 'Supprimer la dernière enchère ?',
  'lot.toolbox.modal.closeAuction.yes': 'Oui',
  'lot.toolbox.modal.closeAuction.no': 'Non',
  'lot.toolbox.modal.closeLot.title':
    'Le montant de la meilleure enchère est inférieur à celui de la réserve.',
  'lot.toolbox.modal.closeLot.subtitle': 'Souhaitez-vous adjuger ?',
  'lot.toolbox.modal.closeLot.yes': 'Oui',
  'lot.toolbox.modal.closeLot.no': 'Non',
  'lot.toolbox.modal.pauseLot.choseTime': 'Choisissez une heure de reprise',
  'lot.toolbox.modal.pauseLot.grabTime': 'Saisissez une heure de reprise',
  'lot.toolbox.modal.pauseLot.validate': 'Valider',
  'salesperson.header.userCounter.spectator.label':
    '{value, plural, zero {spectateur} one {spectateur} other {spectateurs}}',
  'salesperson.header.userCounter.spectator.title':
    'Total des clics sur le bouton du mode spectateur.',
  'salesperson.header.userCounter.identified.label':
    '{value, plural, zero {identifié} one {identifié} other {identifiés}}',
  'salesperson.header.userCounter.identified.title': 'Total des identifiés de la journée.',
  'salesperson.header.userCounter.loggedIn.label':
    '{value, plural, zero {connecté} one {connecté} other {connectés}}',
  'salesperson.header.userCounter.loggedIn.title':
    'Anonymes et identifiés actuellement sur le Live.',
  'salesperson.header.title': 'Vente live de {name}',
  'salesperson.dataTable.company.yes': 'Oui ({name})',
  'salesperson.dataTable.company.no': 'Non',
  'salesperson.dataTable.column.name': 'Nom',
  'salesperson.dataTable.column.email': 'Email',
  'salesperson.dataTable.column.country': 'Pays',
  'salesperson.dataTable.column.lastConnectedAt': 'Connexion',
  'salesperson.dataTable.column.isPro': 'Pro',
  'salesperson.dataTable.column.auctions': 'Enchères',
  'salesperson.header.logout.label': 'Se déconnecter',
  'hall.title': 'VANZARE LIVE',
  'hall.lotNumber.label': 'Nr.{number}',
  'hall.newPrice': 'Pret nou* : {price}',
  'hall.taxes.label': 'TVA',
  'hall.taxes.yes': 'DA',
  'hall.taxes.no': 'NU',
  'client.attr.auction.loading': 'Încărcare...',
  'client.attr.vehicle.photo_next': 'Imaginea următoare',
  'client.attr.vehicle.photo_previous': 'Imaginea precedentă',
  'client.auction.bid': 'Licitați',
  'client.auction.fees_extra': 'Taxe administrative, suplimentare, de {handlingFees} €',
  'client.auction.fees_included': 'Taxe de vânzare incluse',
  'client.auction.few_moments': 'în câteva momente',
  'client.auction.losing': 'Nu sunteți primul',
  'client.auction.lost_text': 'Nu ați câștigat licitația.',
  'client.auction.lot_closed': 'Lot închis',
  'client.auction.next_auction': 'Următoarea licitație',
  'client.auction.opening_in': 'Începerea licitațiilor',
  'client.auction.register_to_bid': 'Înscrieți-vă pentru a licita',
  'client.auction.same_amount': 'Aceeași licitație pentru această sumă',
  'client.auction.seconds': 'Secundă(e)',
  'client.auction.sold': 'Adjudecat',
  'client.auction.starting_price': 'Prețul de începere',
  'client.auction.vat_excluded': 'Fara TVA',
  'client.auction.winning': 'Sunteți primul',
  'client.auction.won_text1': 'Bravo! Ați câștigat licitația',
  'client.auction.won_text2': 'Vă vom contacta.',
  'client.auction.you': 'Dvs.',
  'client.auction.salle': 'Hol',
  'client.auction.interenchères': 'Web',
  'client.auction.web': 'Web',
  'client.auction.live': 'Web',
  'client.auction.oa': 'Web',
  'client.footer.catalog': 'Revenire la catalog',
  'client.footer.footnote.one': 'Taxe administrative, suplimentare: {handlingFees} €, TVA inclusă',
  'client.footer.footnote.three': 'Cod Codex, la data ieșirii sau factura de origine',
  'client.footer.footnote.two':
    'Cotație prorata temporis, sau preț de piață, sau cotație estimată, dată cu titlu indicativ, care nu angajează răspunderea VPauto',
  'client.footer.vehicle_link': 'Fișa detaliată a lotului',
  'client.header.live_from': 'În direct din',
  'client.header.logout': 'Deconectare',
  'client.popup.body.first': 'Intrați în sală în mod licitator.',
  'client.popup.body.second':
    'Un clic pe butonul „Licitare” reprezintă o ofertă și vă angajează responsabilitatea.',
  'client.popup.body.third':
    'Licitațiile sunt efectuate cu taxele de vânzare incluse (cheltuieli administrative suplimentare).',
  'client.popup.confirm': 'Am înțeles',
  'client.popup.header': 'Atenție',
  'client.vehicle.kilometers': 'Km',
  'client.vehicle.lot_number': 'Nr.',
  'client.vehicle.new_price': 'Preț nou',
  'client.vehicle.observations': 'Observație(i)',
  'client.vehicle.options': 'Echipament(e)',
  'client.vehicle.quote': 'Cotă',
  'client.vehicle.vat': 'TVA',
  'client.vehicle.localisation': 'Situare',
  'client.video.live_sale': 'Vezi vânzarea live',
  'loading.app': 'Vă rugăm să așteptați, conectare în curs...',
  'loading.sale': 'Încărcare vânzare, în curs...',
  'loading.vehicle': 'Încărcare vehicul, în curs...',
  'next_sale.content.links.catalog': 'Catalogul vânzării',
  'next_sale.content.links.sale_hours': 'Programul vânzării',
  'next_sale.content.paused': '<bold>Vânzare</bold> în pauză',
  'next_sale.content.restored_in': '<bold>Reluare</bold> peste',
  'next_sale.content.timer.hours': `{hour, plural,
    =0 {oră}
    =1 {oră}
    other {orăe}
  }`,
  'next_sale.content.timer.minutes': `{minute, plural,
    =0 {minut}
    =1 {minut}
    other {minute}
  }`,
  'next_sale.footer.access': 'Alegerea <bold>tipului de acces</bold>',
  'next_sale.footer.guide': '<bold>Instrucțiuni de utilizare</bold> a modului Live',
  'next_sale.footer.main_site': '<bold>Revenire</bold> la VPauto',
  'next_sale.footer.planning': '<bold>Programul</bold> următoarelor vânzări Live',
  'next_sale.footer.sound': '<bold>Ascultare</bold> vânzare',
  'next_sale.footer.sound_instructions': 'Funcționalitatea nu este disponibilă în acest moment.',
  'next_sale.header.live_from': '@:client.header.live_from',
}
